module.exports = __webpack_public_path__ + "img/index_adv.7b2bb844.jpg";